import React from "react";

interface Props { children: React.ReactNode; }
interface State { hasError: boolean; error?: Error; }

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, color: "#fff", background: "#1a1a2e" }}>
          <h1>Something went wrong</h1>
          <pre style={{ color: "#f87171" }}>{this.state.error?.message}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}
